export const convertArrayParamsToString = (params: any[]) => {
  if (params.length === 0) return "";

  const convertedParams = `${params},`;

  return convertedParams;
};
